import * as React from 'react';
import PropTypes from 'prop-types';
import MenuBar from '../../../../components/menuBar/MenuBar';
import OverviewBreadcrumb from '../../../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import CheckoutForm from '../../../../components/checkoutInfo/checkoutForm/CheckoutForm';
import { Col, Row } from 'antd';
import './PaymentCancelPage.css';
import Button from '../../../../components/button/Button';
import FeatureService from '../../../../services/feature/FeatureService';
import Features from '../../../../const/Features';
import * as cancelService from '../../../../services/cancel/CancelService';
import * as CryptoAdyenUC from '../../../../usecases/cryptoAdyen/CryptoAdyenUC';
import InfoModal from '../../../../components/searchBox/infoModal/InfoModal';
import ModalLoad from '../../../../components/modalLoad/ModalLoad';
import { Operation } from '../../../../const/CancelModel';
import { Redirect } from 'react-router-dom';
import pnrToPnrItemModelAssembler from '../../../../services/detail/PnrToPnrItemModelAssembler';
import * as detailPnrService from '../../../../services/detail/DetailPnrService';
import ModalSucessRefund from '../modal/ModalSucessRefund';
import utils from '../../../../components/utils/utils';

const defaultProps = {
  showLoading: false
};

const propTypes = {
  location: PropTypes.object
};

const AMEX = 'amex';
const I18n = require('i18n-react').default;

export default class PaymentCancelPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.setState({
      cardInfo: {
        cardNumber: null,
        cardType: null,
        month: null,
        year: null,
        securityCode: null,
        name: null,
        cnpjCpf: null,
        isRedirect: false
      },
      featureAdyenEncryptedEnabled: false
    })
    const script = document.createElement('script');
    script.src =
      global.env.ADYEN_APP_DOMAIN || 'https://test.adyen.com/hpp/cse/js/7814581483050358.shtml';
    script.async = true;
    document.body.appendChild(script);
    this.featureAdyenCardEncrypted();
    window.scroll(0, 0);
  }

  render() {
    return (
      <div id="PaymentCancelPage">
        <MenuBar hideChangeSearch={true} />

        <OverviewBreadcrumb
          id="componentOverviewBreadcrumb"
          steps={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.cancellation'
          ]}
          actual="features.breadcrumb.cancellation"
        />
        <div className="body-min-height bg-white padding-eight-56">
          <div className="section__outer">
            <Row>
              <Col xs={24} className="CheckoutPage__body">
                <Row>
                  <Button
                    name="returnToSearchResult"
                    className="text-xl returnToSearchResult margin-eight-right-320"
                    background="navy-blue"
                    disabled={false}
                    onClick={() => window.history.back()}>
                    {I18n.translate('label.back')}
                  </Button>
                  <Col xs={12} className="CheckoutPage__formTitle collapsedFixedTitle">
                    <span>{I18n.translate('label.cardPaymentTitle')}</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="CheckoutPage__formSubTitle">
                    <span>{I18n.translate('label.cardPaymentSubtitle')}</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={9} lg={8}>
                    <CheckoutForm
                      id="cardInformation"
                      securityCodeMaxLength={this.getMaxLengthSecurityCode()}
                      changeCreditCard={this.changeCreditCard}
                      changeValidDate={this.changeValidDate}
                      changeSecurityCode={this.changeSecurityCode}
                      changeName={this.changeName}
                      changeCnpjCpf={this.changeCnpjCpf}
                      ref={c => {
                        this.cardForm = c;
                      }}
                    />
                  </Col>
                </Row>

              </Col>
            </Row>
            {this.renderButtonSubmit()}
            {this.renderModalLoading()}

            <InfoModal
              id="modalError"
              message={this.state.messageInfo}
              showModal={this.state.openModal}
              close={this.closeModal}
              ref={c => {
                this.modalError = c;
              }}
            />
            <ModalSucessRefund
              id="modalSucessRefund"
              messageCancelSucessTracker={this.state.messageCancelSucessTracker}
              messageCancelSucess={this.state.messageCancelSucess}
              showModal={this.state.openModalSucessRefund}
              close={this.closeModalSucessRefund}
              ref={c => {
                this.modalSucessRefund = c;
              }}
            />

            {this.state.isRedirect ? (
              <Redirect
                push
                to={{
                  pathname: this.state.urlRedirect,
                  state: {
                    pnrDataDetail: this.state.pnrDataDetail,
                    azulNumber: this.state.azulNumber
                  }
                }}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  renderButtonSubmit() {
    return (
      <div className=" PaymentCancelPage section_buttom">
        <div>
          <Button
            id="btnInitBooking"
            background="shamrock"
            className="PaymentCancelPage submit pull-right text-xl"
            onClick={this.submitPayment}
            disabled={false}>
            {I18n.translate('label.payment')}
          </Button>
        </div>
      </div>
    );
  }

  renderModalLoading() {
    return (
      <ModalLoad
        id="modalLoad"
        showModal={this.state.showLoading}
        ref={c => {
          this.modalLoad = c;
        }}
      />
    );
  }

  showModalSucessRefund(messageCancelSucessTracker, messageCancelSucess) {
    this.setState({
      openModalSucessRefund: true,
      messageCancelSucessTracker: messageCancelSucessTracker,
      messageCancelSucess: messageCancelSucess
    });
  }

  closeModalSucessRefund = () => {
    this.setState({
      openModalSucessRefund: false
    });
    this.callDetailPnr(this.props.location.state.cancelModel.pnrId)
  };


  submitPayment = () => {
    if (this.validate()) {
      this.setState({
        showLoading: true
      });
      let payment = this.state.cardInfo;
      let cancelModel = this.props.location.state.cancelModel;
      let azulNumber = this.props.location.state.azulNumber;

      if (this.state.featureAdyenEncryptedEnabled) {
        CryptoAdyenUC.execute(payment)
          .then(adyenResponse => {
            cancelService.paymentEncrypted(azulNumber, payment, cancelModel, false, adyenResponse.cardEncrypted)
              .then(response => {
                if (response && response.error) throw response;
                utils.addScroll();
                this.showModalSucessRefund(
                  I18n.translate('context.cancelPnrPage.cancelSuccessTracker', { pnr: cancelModel.pnrNumber }),
                  I18n.translate('context.cancelPnrPage.cancelSuccess')
                );
              })
              .catch(error => {
                this.setState({
                  showLoading: false
                });
                utils.addScroll();
                this.getError(error);
              });
          })
          .catch(error => {
            this.setState({
              showLoading: false
            });
            utils.addScroll();
            this.showModal(I18n.translate('home.msg.error'));
          });
      } else {
        cancelService.cancel(azulNumber, payment, cancelModel, Operation.PAYMENT, false, false)
          .then(response => {
            if (response && response.error) throw response;
            utils.addScroll();
            this.showModalSucessRefund(
              I18n.translate('context.cancelPnrPage.cancelSuccessTracker', { pnr: cancelModel.pnrNumber }),
              I18n.translate('context.cancelPnrPage.cancelSuccess')
            );
          })
          .catch(error => {
            this.setState({
              showLoading: false
            });
            utils.addScroll();
            this.getError(error);
          });
      }
    }
  }

  getError(error) {    
		if (error && error.response && error.response.data) {
			if (error.response.data.reason)
				this.showModal(error.response.data.reason);
			else
				this.showModal(I18n.translate('home.msg.error') + ' Error: ' + error.response.data.message);
		} else
			this.showModal(I18n.translate('home.msg.error'));
	}

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };

  featureAdyenCardEncrypted() {
    FeatureService.isFeatureEnabled(Features.ADYEN_CARD_ENCRYPTED)
      .then(isEnabled => {
        this.setState({
          featureAdyenEncryptedEnabled: isEnabled
        });
      })
      .catch(() => { });
  }

  callDetailPnr(pnrId) {
    this.setState({
      showLoading: true
    });
    detailPnrService.detailPnr(pnrId)
      .then(response => {
        if (response && response.error) throw response;
        this.setState({
          pnrDataDetail: pnrToPnrItemModelAssembler.assemblePnrItemModel(response.data),
          showLoading: false,
          isRedirect: true,
          urlRedirect: 'flightDetails',
          azulNumber: this.props.location.state.azulNumber
        });
      })
      .catch(error => {
        this.setState({
          showLoading: false
        });
        utils.addScroll();
        this.showModal(I18n.translate('home.msg.error'));
      });
  }

  validate() {
    let isValidForm = false;
    if (this.cardForm) {
      isValidForm = true;
      this.cardForm.fields.forEach(field => {
        if (field.props.id === 'cardValidDate') {
          let isMonthValid = field.monthField.validate();
          if (!isMonthValid && isValidForm) {
            field.monthField.input.focus();
            isValidForm = false;
          }
          let isYearValid = field.yearField.validate();
          if (!isYearValid && isValidForm) {
            field.yearField.input.focus();
            isValidForm = false;
          }
          let isDateValid = field.validate();
          if (!isDateValid && isValidForm) {
            field.monthField.input.focus();
            isValidForm = false;
          }
        } else {
          let isFieldValid = field.validate();
          if (!isFieldValid && isValidForm) {
            field.input.focus();
            isValidForm = false;
          }
        }
      });
    }
    return isValidForm;
  };

  getMaxLengthSecurityCode() {
    let maxLength = 4;
    if (this.state && this.state.cardInfo && this.state.cardInfo.cardType !== AMEX) {
      maxLength = 3;
    }
    return maxLength;
  }

  changeCreditCard = (value, type) => {
    this.setState({
      cardInfo: {
        ...this.state.cardInfo,
        cardNumber: value,
        cardType: type
      }
    });

  };

  changeValidDate = (month, year) => {
    this.setState({
      cardInfo: {
        ...this.state.cardInfo,
        month: month,
        year: year
      }
    });
  };

  changeSecurityCode = value => {
    this.setState({
      cardInfo: {
        ...this.state.cardInfo,
        securityCode: value
      }
    });
  };

  changeName = value => {
    this.setState({
      cardInfo: {
        ...this.state.cardInfo,
        name: value
      }
    });
  };

  changeCnpjCpf = value => {
    this.setState({
      cardInfo: {
        ...this.state.cardInfo,
        cnpjCpf: value
      }
    });
  };

}

PaymentCancelPage.propTypes = propTypes;
PaymentCancelPage.defaultProps = defaultProps;


// WEBPACK FOOTER //
// ./src/page/cancelPnr/components/paymentCancel/PaymentCancelPage.jsx